module.exports = __webpack_public_path__ + "static/media/img8.79433dbc.jpg";